module.exports = __webpack_public_path__ + "static/media/Filip.447a09bf.jpg";